<template>
    <div>
        <h3>{{ annex.number }}. {{ annex.question }}</h3>
        <draggable v-model="ordered" group="people" @start="drag=true" @end="drag=false" class="list-group">
            <div v-for="element in ordered" :key="element.id" class="list-group-item list-group-item-secondary">{{element.text}}</div>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import { mapActions } from "vuex";

export default {
    data() {
        return {
            ordered: this.annex.options,
        };
    },
    props: ["annex"],
    methods: {
        ...mapActions(["setAnnex"]),
    },
    components: {
        draggable,
    },
    watch: {
        ordered: function () {
            this.setAnnex({
                annex: this.annex.id,
                answers: this.ordered,
            });
        },
    },
    mounted() {
        this.setAnnex({
            annex: this.annex.id,
            answers: this.ordered,
        });
    },
};
</script>

<style>
</style>
